import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/lib/content";
import { Reveal } from "./Reveal";

const field = "mt-2 block w-full bg-transparent border-b border-pine/40 py-2 normal-case tracking-normal text-base focus:outline-none focus:border-brass transition-colors";

export const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/contact`, form);
      setSent(true);
      setForm({ name: "", email: "", message: "" });
      toast.success("Thank you. Your note has been received.");
    } catch {
      toast.error("Please check your name, email and message, then try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="contact" className="bg-paper text-pine py-24 md:py-32 scroll-mt-20" data-testid="contact-section">
      <Reveal className="max-w-2xl mx-auto px-6">
        <h2 className="dp">Send a note</h2>
        <p className="mt-4 text-moss">Everything you share stays confidential.</p>
        {sent && (
          <p className="mt-6 rounded-2xl bg-sage px-5 py-4" data-testid="contact-success">
            Your note is with us. We'll be in touch soon.
          </p>
        )}
        <form className="mt-8 grid gap-6" onSubmit={submit} data-testid="contact-form">
          <label className="lb">Name<input required value={form.name} onChange={set("name")} className={field} data-testid="contact-name-input" /></label>
          <label className="lb">Email<input required type="email" value={form.email} onChange={set("email")} className={field} data-testid="contact-email-input" /></label>
          <label className="lb">Message<textarea required rows="3" value={form.message} onChange={set("message")} className={field} data-testid="contact-message-input" /></label>
          <button type="submit" disabled={sending} className="mt-4 bg-pine text-sage rounded-full py-4 transition-colors hover:bg-pine-soft disabled:opacity-70" data-testid="contact-submit-button">
            {sending ? "Sending..." : "Send"}
          </button>
        </form>
      </Reveal>
    </section>
  );
};
